import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

interface IValueProp {
  title: string;
  description: string;
  iconUrl: string;
  darkIconUrl?: string;
}

interface ILink {
  displayText: string;
  url: string;
  leadingIcon: string;
  trailingIcon: string;
  darkLeadingIcon?: string;
  darkTrailingIcon?: string;
}

interface IConfig {
  assetUrl: string;
  darkAssetUrl?: string;
  titleText: string;
  description: string;
  valuePropositions: IValueProp[];
  link: ILink;
}

@Component({
  selector: 'walk-guidance-webview',
  templateUrl: './walk-guidance-integrated-webview.component.html',
  styleUrls: ['./walk-guidance-integrated-webview.component.css']
})
export class WalkGuidanceIntegratedWebviewComponent implements OnInit {

  place: string;
  hasVpIcons = false;
  WalkGuidanceIntegratedConfig: string;
  error = false;
  darkMode = false;
  configuration: IConfig;
  constructor(
    private route: ActivatedRoute,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {
    this.error = false;
    try {
      this.WalkGuidanceIntegratedConfig = JSON.parse(environment.WalkGuidanceIntegratedConfig);
      this.route.queryParams.subscribe(params => {
        if (params) {
          params.darkMode && params.darkMode === 'true' ? this.enableDarkMode() : "";
          this.place = params.placeName || "";
          if (this.place && this.WalkGuidanceIntegratedConfig && this.WalkGuidanceIntegratedConfig[this.place]) {
            this.configuration = this.WalkGuidanceIntegratedConfig[this.place];
          } else {
            this.error = true;
            return;
          }
        } else {
          this.error = true;
          return;
        }
      })

      this.checkIcons();

    } catch (e) {
      this.error = true;
    }
  }

  enableDarkMode() {
    this.darkMode = true;
    this.renderer.addClass(document.body, "dark-mode");
  }

  checkIcons() {
    if (this.configuration && this.configuration.valuePropositions && this.configuration.valuePropositions.length) {
      this.hasVpIcons = true;
      for (let proposition of this.configuration.valuePropositions) {
        if (!proposition.iconUrl || proposition.iconUrl == "") {
          this.hasVpIcons = false;
          break;
        }
      }
    }
  }

  renderTitle(title) {
    var newText = title.replace(/\n/g, "<br>");
    return newText;
  }
}
